const styles = {
  listItem: {
    p: 1,
    mb: 1,
  },
  listTextTitles: {
    mb: 1,
  },

}

export default styles
